//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { date } from "quasar";
//import wrapCsvValue from "../../mixins/wrapCsvValue";
export default {
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 30,
        sortBy: "created",
        descending: true,
        rowsNumber: 0,
      },
      columns: [
        {
          name: "reference",
          align: "left",
          label: "#",
          field: "reference",
          sortable: true,
        },
        {
          name: "transactionTypeId",
          align: "left",
          label: this.$t("stock.transactionType"),
          field: "transactionTypeId",
          format: (val) => this.$t(`stock.transactionType-${val}`),
          sortable: true,
        },
        {
          name: "productNumber",
          align: "left",
          label: this.$t("stock.productNo"),
          field: "productNumber",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: this.$t("stock.productName"),
          field: "productName",
          sortable: true,
        },
        {
          name: "warehouseName",
          align: "left",
          label: this.$t("stock.warehouse"),
          field: "warehouseName",
          sortable: true,
        },
        {
          name: "locationName",
          align: "left",
          label: this.$t("stock.location"),
          field: "locationName",
          sortable: true,
        },
        {
          name: "transactionQuantity",
          align: "right",
          label: this.$t("stock.transactionQuantity"),
          field: "transactionQuantity",
          sortable: true,
        },
        {
          name: "locationNewQuantity",
          align: "right",
          label: this.$t("stock.locationNewQuantity"),
          field: "locationNewQuantity",
          sortable: true,
        },
        {
          name: "comment",
          align: "left",
          label: this.$t("stock.comment"),
          field: "comment",
          sortable: true,
        },
        {
          name: "createdByDisplayName",
          align: "left",
          label: this.$t("common.createdBy"),
          field: "createdByDisplayName",
          sortable: true,
        },
        {
          name: "created",
          align: "left",
          label: this.$t("common.created"),
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          field: "created",
          sortable: true,
        },
      ],
      filter: "",
      timerId: null,
      Transactions: [],
    };
  },
  async mounted() {
    await this.refresh();
  },

  watch: {
    filter(newValue, oldValue) {
      if (newValue != oldValue) {
        clearTimeout(this.timerId);
        this.pagination.page = 1;
        this.timerId = setTimeout(this.refresh, 2000);
      }
    },
  },

  methods: {
    ...mapActions("main", ["getStockTransactions"]),

    async refresh() {
      this.Transactions = [];
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      const payload = {
        pageNumber: this.pagination.page,
        pageSize: this.pagination.rowsPerPage,
        sortBy: this.pagination.sortBy,
        sortDescending: this.pagination.descending,
        searchQuery: this.filter,
      };

      try {
        const data = await this.getStockTransactions(payload);
        this.Transactions = data.items;
        this.pagination.rowsNumber = data.totalCount;
      } catch (error) {
        console.error("Error fetching stock transactions:", error);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorFetchingData"),
        });
      }

      setTimeout(() => {
        notif();
      }, 500);
    },

    onRequest(params) {
      Object.assign(this.pagination, params.pagination);
      this.refresh();
    },
  },
};
